import React from "react";
import styled from "styled-components";
import { useQuery } from "@apollo/client";
import { GET_TRANSACTION_BY_ID } from "../../../graphql/queries/transaction";
import { printNested } from "../../../utils/general";
import environment from "../../../env";
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: right;
  align-items: flex-start;
  padding-top: 75px;
`;
const ModalContent = styled.div`
  background-color: white;
  margin: 20px;
  padding: 20px;
  width: 400px;
  border-radius: 10px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
`;
const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-top: 20px; // To add space below the title
`;
const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
`;
const Title = styled.h1`
  font-size: 24px;
  font-family: "GT Walsheim Pro";
  font-size: 26px;
  font-weight: 500;
  color: #09005b;
  margin-bottom: 0;
`;
const TransactionDetails = styled.div`
  padding: 20px;
  border-radius: 8px;
  background-color: #f9f9f9;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;
const TableHead = styled.thead`
  background-color: #f2f2f2;
`;
const TableRow = styled.tr``;
const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  font-size: 16px;
`;
const TableCell = styled.td`
  padding: 10px;
  border-top: 1px solid #ddd;
`;
const LoadingText = styled.p`
  font-size: 16px;
  color: #555;
`;
const ErrorText = styled.p`
  font-size: 16px;
  color: #f00;
`;
interface TransactionModalProps {
  transactionId: string;
  onClose: () => void;
}
const TransactionModal: React.FC<TransactionModalProps> = ({
  transactionId,
  onClose,
}) => {
  const { loading, error, data } = useQuery(GET_TRANSACTION_BY_ID, {
    variables: {
      ...environment.paymentLinkService,
      getTransactionByIdId: transactionId,
    },
  });
  const transaction = printNested(data?.getTransactionById || {}, [
    "organizationId",
    "id",
  ]);
  const handleOverlayClick = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };
  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <CloseButton onClick={onClose}>✖</CloseButton>
        <Title>Transaction Details</Title>
        <ModalBody>
          {loading && <LoadingText>Loading...</LoadingText>}
          {error && <ErrorText>Error: {error.message}</ErrorText>}
          {data?.getTransactionById && (
            <TransactionDetails>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeaderCell>Field</TableHeaderCell>
                    <TableHeaderCell>Value</TableHeaderCell>
                  </TableRow>
                </TableHead>
                <tbody>
                  {transaction?.map(({ label, value }) => (
                    <TableRow key={label}>
                      <TableHeaderCell>{label}</TableHeaderCell>
                      <TableCell>{value}</TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </Table>
            </TransactionDetails>
          )}
        </ModalBody>
      </ModalContent>
    </ModalOverlay>
  );
};
export default TransactionModal;
